import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useDispatch, useSelector} from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import  maleAvatar  from '../../assets/images/mine/male_avatar.svg'
import { logout } from '../../redux/features/userSlice';

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <div 
  role="button"
  className="avatar avatar-sm p-0"
  onClick={(e) => {
    e.preventDefault();
    onClick(e);
  }}
  ref={ref}
  >
  {children}
  </div>
));


const CustomMenu = React.forwardRef(
  ({ children, className, 'aria-labelledby': labeledBy }, ref) => {

    

    return (
      <div
        ref={ref}
        className={className}
        aria-labelledby={labeledBy}
      >
        
        {children}
      </div>
    );
  },
);

function Profile() {

  const navigate = useNavigate()

  const { user } = useSelector(state=>state.userState)

  const [show, setShow] = useState(false);

  const dispatch = useDispatch();

  const handleNavigate = (path) => {
    setShow(false)
    navigate(path)
  }


  return (
    <Dropdown 
      className="ms-1 ms-lg-0"
      show={show}
      onToggle={()=> setShow(prev => !prev)}
    >
    <Dropdown.Toggle as={CustomToggle}>
      <img class="avatar-img rounded-circle" src={maleAvatar} alt="avatar"/>
    </Dropdown.Toggle>

    <Dropdown.Menu as={CustomMenu}
        className="dropdown-animation dropdown-menu-end shadow pt-3">
         
              {/* <!-- Profile info --> */}
              <li class="px-3 mb-3">
                <div class="d-flex align-items-center">
                  {/* <!-- Avatar --> */}
                  <div class="avatar me-3">
                    <img class="avatar-img rounded-circle shadow" src= {maleAvatar} alt="avatar"/>
                  </div>
                  <div>
                    <Link to={`/instructor-records`} class="h6">{user.profile.name}</Link>
                    <p class="small m-0">{user.email}</p>
                  </div>
                </div>
              </li>
              <li> <hr class="dropdown-divider"/></li>
              {/* <!-- Links --> */}
 
              <li onClick={()=> dispatch(logout())}>
                <button class="dropdown-item bg-danger-soft-hover"><i class="bi bi-power fa-fw me-2"></i>تسجيل الخروج</button>
              </li>

    </Dropdown.Menu>
    
  </Dropdown>
  )
}

export default Profile